// src/sectors/pilates/staff/api/staffApi.js
import { http } from 'shared/api/http';

export const staffApi = {
  list() {
    console.log('🟢 [staffApi.list] GET /staff');
    return http('/api/v1/pilates/staff', { method: 'GET' }).then((r) => {
      console.log('🟢 [staffApi.list] response:', r);
      return Array.isArray(r) ? r : [];
    });
  },

  create(dto) {
    console.log('🟡 [staffApi.create] payload:', dto);
    return http('/api/v1/pilates/staff', { method: 'POST', body: dto });
  },

  update(staffId, dto) {
    console.log(`🟡 [staffApi.update] staffId=${staffId}`, dto);
    return http(`/api/v1/pilates/staff/${staffId}`, { method: 'PUT', body: dto });
  },

  createLogin(staffId, body) {
    console.log(`🟡 [staffApi.createLogin] staffId=${staffId}`, body);
    return http(`/api/v1/pilates/staff/${staffId}/create-login`, { method: 'POST', body });
  },

  updateLoginCredentials(staffId, body) {
    console.log(`🟡 [staffApi.updateLoginCredentials] staffId=${staffId}`, body);
    return http(`/api/v1/pilates/staff/${staffId}/login/credentials`, { method: 'PUT', body });
  },

  updatePermissions(staffId, body) {
    console.log(`🟡 [staffApi.updatePermissions] staffId=${staffId}`, body);
    return http(`/api/v1/pilates/staff/${staffId}/permissions`, { method: 'PUT', body });
  },

  getLogin(staffId) {
    console.log(`🟢 [staffApi.getLogin] staffId=${staffId}`);
    return http(`/api/v1/pilates/staff/${staffId}/login`, { method: 'GET' });
  },

  // 🔥 KRİTİK LOG BURADA
  toggleActive(staffId, active) {
    const value = typeof active === 'object' ? Boolean(active?.active) : Boolean(active);

    console.group('🔴 [staffApi.toggleActive]');
    console.log('staffId:', staffId);
    console.log('active param (raw):', active);
    console.log('normalized:', value);
    console.log('request body:', { active: value });
    console.groupEnd();

    return http(`/api/v1/pilates/staff/${staffId}/active`, {
      method: 'PUT',
      body: { active: value },
    });
  },

  // 🧠 Seans ekleme ekranı için eğitmen picker (id + fullName)
  trainerPicker() {
    return http('/api/v1/pilates/staff/trainer-picker', { method: 'GET' }).then((r) => {
      return Array.isArray(r) ? r : [];
    });
  },

  // ✅ login kapat/aç
  setLoginStatus(staffId, status) {
    console.log('🔴 [staffApi.setLoginStatus]');
    console.log('staffId:', staffId);
    console.log('status:', status);

    const body = { status }; // "SUSPENDED" | "ACTIVE"
    console.log('request body:', body);

    return http(`/api/v1/pilates/staff/${staffId}/login/status`, {
      method: 'PUT',
      body,
    });
  },
};
